var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVansWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg2",
    width: 1600,
    height: 1600,
    viewBox: "0 0 1600 1600",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path30",
    d: "M 0,1200 H 1200 V 0 H 0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,1600)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g12",
    transform: "translate(343.6171,801.4947)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "m 0,0 h 77.412 l -126.83,-399.544 h -95.435 l -129.364,397.487 78.253,-0.294 101.154,-305.375 z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "evenodd",
    stroke: "none",
    d: "M 1062.421,802.024 H 343.81 v -68.777 h 718.611 z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g18",
    transform: "translate(500.9989,495.0999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path20",
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M 0,0 -23.71,97.128 -46.234,0 Z m -67.577,-92.712 h -69.944 l 78.238,270.777 H 13.042 L 91.297,-92.712 h -71.14 l -8.301,35.325 h -71.139 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g22",
    transform: "translate(683.5916,673.1644)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path24",
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "m 0,0 78.238,-147.159 -2.366,61.811 V 0 h 68.765 V -270.776 H 77.059 l -78.254,147.163 3.561,-61.811 v -85.352 H -66.406 V 0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g26"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g28",
    clipPath: "url(#clipPath32)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g34",
    transform: "translate(1051.1268,595.1754)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path36",
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "m 0,0 h -67.586 c -0.794,8.827 -4.347,14.711 -10.668,17.65 -3.971,3.915 -9.898,5.888 -17.791,5.888 -15.818,0 -23.71,-5.398 -23.71,-16.183 0,-9.821 14.229,-19.126 42.696,-27.965 55.305,-16.688 82.994,-45.139 82.994,-85.345 -1.604,-59.853 -35.581,-90.258 -101.98,-91.244 -57.704,2.944 -90.101,32.377 -97.215,88.296 h 68.765 c 2.373,-9.817 6.328,-17.177 11.854,-22.074 5.527,-3.93 12.248,-5.887 20.149,-5.887 20.559,0 30.833,6.373 30.833,19.13 0,10.785 -13.827,20.097 -41.492,27.962 -56.141,16.663 -84.182,46.101 -84.182,88.292 1.572,55.919 32.791,84.847 93.663,86.824 C -38.357,84.354 -7.115,55.915 0,0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g38",
    transform: "translate(1127.4716,680.2996)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path40",
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "m 0,0 h -3.144 c -0.017,-12.06 -9.77,-21.818 -21.834,-21.842 -12.056,0.024 -21.817,9.782 -21.825,21.842 0.008,12.056 9.769,21.813 21.825,21.838 C -12.914,21.813 -3.161,12.056 -3.144,0 H 0 3.129 c 0,15.525 -12.586,28.102 -28.107,28.106 C -40.499,28.102 -53.076,15.525 -53.076,0 c 0,-15.529 12.577,-28.11 28.098,-28.114 C -9.457,-28.11 3.129,-15.529 3.129,0 Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g42",
    transform: "translate(1097.7456,692.2388)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path44",
    fill: "#fff",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "m 0,0 v -11.057 c 7.01,-0.233 10.531,1.933 10.531,6.497 0,4.091 -2.583,6.14 -7.724,6.14 C 0.706,1.696 -0.233,1.167 0,0 m 20.526,-25.619 v -0.875 H 13.162 L 2.631,-12.633 0,-12.806 v -8.774 c -0.353,-2.808 0.995,-4.156 4.026,-4.039 v -0.875 H -8.422 v 0.875 c 3.04,-0.237 4.323,1.287 3.858,4.563 V -1.58 c 0.353,2.811 -0.939,4.159 -3.858,4.038 V 3.164 H 4.026 c 7.492,-0.12 11.302,-2.695 11.414,-7.724 0,-4.211 -2.695,-6.73 -8.069,-7.544 l 9.129,-11.41 c 1.17,-1.403 2.51,-2.105 4.026,-2.105"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVansWhite);
export default __webpack_public_path__ + "static/media/vans_white.75ccbbcabc4384cbb4dfc7f38bf1598f.svg";
export { ForwardRef as ReactComponent };